module.exports = __webpack_public_path__ + "images/wire-transfer-6e13e4d990850165929dff951739456d.png";